module.exports = __webpack_public_path__ + "media/images/soar/avatar_default-eaa0bc3028ff642a440c6095e4351929.jpg";